function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_-_Trash-Can-_3844425",
  transform: "translate(-3 -2)"
}, React.createElement("path", {
  id: "XMLID_237_",
  d: "M6,12v9.231a1.848,1.848,0,0,0,1.846,1.846h8.615a1.848,1.848,0,0,0,1.846-1.846V12Zm3.692,8a.615.615,0,1,1-1.231,0V14.462a.615.615,0,1,1,1.231,0Zm3.077,0a.615.615,0,1,1-1.231,0V14.462a.615.615,0,1,1,1.231,0Zm3.077,0a.615.615,0,1,1-1.231,0V14.462a.615.615,0,1,1,1.231,0Z",
  transform: "translate(-1.154 -3.846)",
  fill: "#949db2"
}), React.createElement("path", {
  id: "XMLID_243_",
  d: "M17.769,4.462H14.077V3.846A1.848,1.848,0,0,0,12.231,2H9.769A1.848,1.848,0,0,0,7.923,3.846v.615H4.231A1.232,1.232,0,0,0,3,5.692v.615a.616.616,0,0,0,.615.615H18.385A.616.616,0,0,0,19,6.308V5.692A1.232,1.232,0,0,0,17.769,4.462ZM9.154,3.846a.616.616,0,0,1,.615-.615h2.462a.616.616,0,0,1,.615.615v.615H9.154Z",
  fill: "#949db2"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 17.231,
    viewBox: "0 0 16 17.231"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/delete.09b7a4fe.svg";
export { SvgComponent as ReactComponent };